// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DeleteCompanyPage-actionContainer-zUj51 {\n  align-items: start;\n}\n.DeleteCompanyPage-inputContainer-PVYAI {\n  margin: 10px 0 0 10px;\n  display: flex;\n}\n.DeleteCompanyPage-label-2IhqS {\n  margin: 0 5px 0 0;\n  text-align: right;\n}\n.DeleteCompanyPage-description-3wAwg {\n  padding-left: 1.5em;\n  color: #4d4d4c;\n  font-size: 15px;\n  margin-bottom: 20px;\n  --fi-size: 18px;\n}\n", ""]);
// Exports
exports.locals = {
	"actionContainer": "DeleteCompanyPage-actionContainer-zUj51",
	"inputContainer": "DeleteCompanyPage-inputContainer-PVYAI",
	"label": "DeleteCompanyPage-label-2IhqS",
	"description": "DeleteCompanyPage-description-3wAwg"
};
module.exports = exports;
